export default __webpack_public_path__ + "static/media/DAIF_Services_Loop.93f727ef.mp4";